var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgDeliverect(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 24,
    viewBox: "0 0 129 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_deliverect",
    clipPath: "url(#clip0_3654_6205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1024 3.56879V12.153C20.1024 16.3948 16.6545 19.833 12.4009 19.833C8.14721 19.833 4.69938 16.3948 4.69938 12.153C4.69938 7.91122 8.14721 4.47301 12.4009 4.47301H13.2568V9.59326H12.4009C10.9832 9.59326 9.83397 10.7393 9.83397 12.153C9.83397 13.5667 10.9832 14.7128 12.4009 14.7128C13.8185 14.7128 14.9678 13.5667 14.9678 12.153V0.922451C14.1416 0.735211 13.2834 0.633789 12.4009 0.633789C6.02077 0.633789 0.848633 5.7915 0.848633 12.1538C0.848633 18.5161 6.02077 23.6738 12.4009 23.6738C18.781 23.6738 23.9531 18.5161 23.9531 12.1538C23.9531 8.74288 22.4651 5.67837 20.1024 3.56879Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.9774 18.3332C49.3857 18.3332 50.4426 17.7013 51.006 16.8821L53.0956 18.0992C52.0159 19.6907 50.2549 20.6511 47.954 20.6511C44.0805 20.6511 41.5684 18.0056 41.5684 14.494C41.5684 10.9825 44.0806 8.33691 47.7662 8.33691C51.4519 8.33691 53.6589 11.1463 53.6589 14.5174C53.6589 14.8685 53.612 15.243 53.565 15.5706H44.2213C44.6204 17.397 46.0998 18.3332 47.9774 18.3332ZM51.0998 13.511C50.7478 11.4973 49.2683 10.6314 47.7427 10.6314C45.8409 10.6314 44.55 11.7548 44.1978 13.511H51.0998Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.3018 3.69434H57.8374V20.3463H55.3018V3.69434Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.6289 5.27003C59.6289 4.38063 60.3565 3.6543 61.2483 3.6543C62.1403 3.6543 62.8679 4.37986 62.8679 5.27003C62.8679 6.1602 62.1403 6.88498 61.2483 6.88498C60.3565 6.88498 59.6289 6.13602 59.6289 5.27003ZM59.981 8.64115H62.5166V20.346H59.981V8.64115Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M75.9735 8.64111L71.396 20.346H68.4614L63.8838 8.64111H66.6541L69.9408 17.5374L73.204 8.64111H75.9735Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.3543 18.3332C83.7626 18.3332 84.8195 17.7013 85.3828 16.8821L87.4725 18.0992C86.3929 19.6907 84.6317 20.6511 82.3309 20.6511C78.4574 20.6511 75.9453 18.0056 75.9453 14.494C75.9453 10.9825 78.4574 8.33691 82.1431 8.33691C85.8287 8.33691 88.0358 11.1463 88.0358 14.5174C88.0358 14.8685 87.9888 15.243 87.9419 15.5706H78.5983C78.9972 17.397 80.4767 18.3332 82.3543 18.3332ZM85.4767 13.511C85.1246 11.4973 83.6453 10.6314 82.1196 10.6314C80.2177 10.6314 78.9268 11.7548 78.5748 13.511H85.4767Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95.521 8.43066V11.1698C93.8546 11.0528 91.9057 11.8252 91.9057 14.4473V20.347H89.3701V8.64209H91.9057V10.6089C92.6098 9.01736 94.0424 8.43066 95.521 8.43066Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M102.251 18.3332C103.659 18.3332 104.716 17.7013 105.279 16.8821L107.369 18.0992C106.29 19.6907 104.528 20.6511 102.227 20.6511C98.3543 20.6511 95.8418 18.0056 95.8418 14.494C95.8418 10.9825 98.3543 8.33691 102.039 8.33691C105.726 8.33691 107.932 11.1463 107.932 14.5174C107.932 14.8685 107.885 15.243 107.839 15.5706H98.4949C98.8934 17.397 100.373 18.3332 102.251 18.3332ZM105.373 13.511C105.021 11.4973 103.541 10.6314 102.016 10.6314C100.114 10.6314 98.8231 11.7548 98.4718 13.511H105.373Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M108.929 14.4935C108.929 11.0054 111.582 8.33643 115.126 8.33643C117.427 8.33643 119.423 9.53009 120.363 11.3565L118.179 12.6203C117.662 11.5203 116.513 10.8181 115.103 10.8181C113.037 10.8181 111.464 12.3863 111.464 14.4935C111.464 16.6008 113.037 18.1689 115.103 18.1689C116.512 18.1689 117.662 17.4434 118.225 16.366L120.41 17.6064C119.424 19.4562 117.427 20.6499 115.126 20.6499C111.582 20.6499 108.929 17.9582 108.929 14.4935Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M125.48 11.0754V16.6942C125.48 18.1921 126.466 18.1687 128.391 18.075V20.3461C124.494 20.8143 122.945 19.7377 122.945 16.6942V11.0754H120.785V8.64048H122.945V5.14453H125.48V8.64048H128.391V11.0754H125.48Z",
    fill: "#05CC79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M37.5813 3.69434V9.51676C36.5534 8.77091 35.2766 8.33636 33.8863 8.33636C30.4588 8.33636 27.6885 11.0053 27.6885 14.4934C27.6885 17.9816 30.4588 20.6506 33.8863 20.6506C37.3138 20.6506 40.0841 17.9582 40.0841 14.4934V3.69434H37.5813ZM33.8863 18.1922C31.8201 18.1922 30.2241 16.6242 30.2241 14.4934C30.2241 12.3628 31.8201 10.7946 33.8863 10.7946C35.9525 10.7946 37.5485 12.3628 37.5485 14.4934C37.5485 16.6242 35.9517 18.1922 33.8863 18.1922Z",
    fill: "#05CC79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3654_6205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeliverect);
export default __webpack_public_path__ + "static/media/img_deliverect.20128bff2662d6082853ca84d312c7c0.svg";
export { ForwardRef as ReactComponent };